var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-bar-service",attrs:{"hidden":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }